import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFacebookSDKActions } from '../actions/facebookActions';
import { selectEnv } from '../selectors/envSelectors';

export const useInitFacebookSDK = (fbVersion?: string) => {
  const { init: initFacebookSDK } = useFacebookSDKActions();
  const { fbAppId } = useSelector(selectEnv);

  useEffect(() => {
    if (fbAppId) {
      initFacebookSDK(fbAppId as any, fbVersion);
    }
  }, [fbAppId]);
};
